(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ambo-product-showcase"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click',function(event){var button=event.target.closest('[data-ambo-showcase-next]');if(!button)return;var section=button.closest('[data-ambo-showcase]');var rail=section&&section.querySelector('.ambo-showcase__rail');if(rail)rail.scrollBy({left:rail.clientWidth*.85,behavior:'smooth'});});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ambo-tabbed-products"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click',function(event){var tab=event.target.closest('[data-ambo-tab]');if(!tab)return;var section=tab.closest('[data-ambo-tabbed]');if(!section)return;var key=tab.getAttribute('data-ambo-tab');section.querySelectorAll('[data-ambo-tab]').forEach(function(item){var active=item===tab;item.classList.toggle('is-active',active);item.setAttribute('aria-selected',active?'true':'false');item.tabIndex=active?0:-1;});section.querySelectorAll('[data-ambo-panel]').forEach(function(panel){var active=panel.getAttribute('data-ambo-panel')===key;panel.hidden=!active;panel.classList.toggle('is-active',active);});var link=section.querySelector('[data-ambo-collection-link]');var collectionUrl=tab.getAttribute('data-collection-url');if(link&&collectionUrl)link.setAttribute('href',collectionUrl);});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
